import { URLS } from 'api/constants';
import { ISlot } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationRequest, PaginationResponse } from './types';

type ApiParams = Record<string, string | number | boolean | undefined | null>;

export async function getSlotById(id?: string) {
  const data = await apiGetSafe<ISlot & PaginationResponse<ISlot>>(
    `${URLS.SLOTS}${id ?? ''}`
  );

  if (!data) {
    return null;
  }

  if ('results' in data && Array.isArray(data.results)) {
    return (data.results[0] ?? null) as ISlot | null;
  }

  return (data as ISlot) ?? null;
}

export async function listSlots(
  params: PaginationRequest & {
    countries?: string | null;
    collections?: string;
  } = {}
) {
  return apiGet<PaginationResponse<ISlot>>(URLS.SLOTS, params as ApiParams);
}

export async function listSlotsByCasino(
  id: string,
  params: PaginationRequest = {}
) {
  return apiGet<PaginationResponse<ISlot>>(
    `${URLS.SLOTS_BY_CASINO}/${id}`,
    params as ApiParams
  );
}

export async function listSlotsByProvider(
  id: string,
  params: PaginationRequest = {}
) {
  return apiGet<PaginationResponse<ISlot>>(
    `${URLS.SLOTS_BY_PROVIDER}/${id}`,
    params as ApiParams
  );
}
